import type { FileRecord } from "types/file-record";

type DownloadableFile = Pick<FileRecord, "fileName"> & { id: number | string };

export const openFilePreview = async (
  file: File | DownloadableFile,
  downloadFile: (id: number | string, fileName: string, publicId?: string) => Promise<void>,
  // Public recipients (e.g. survey attachments) authorise downloads via publicId.
  publicId?: string
) => {
  if (file instanceof File) {
    const previewUrl = URL.createObjectURL(file);

    window.open(previewUrl, "_blank", "noopener,noreferrer");

    window.setTimeout(() => {
      URL.revokeObjectURL(previewUrl);
    }, 1000);

    return;
  }

  await downloadFile(file.id, file.fileName, publicId);
};